<div class="formly-field-wrap location-field">
  @if(!isDisabled()) {
    <!-- Active Mode: Editable -->
    <div class="location-controls">
      <!-- Manual Address Input -->
      <div class="address-input-group" [class.has-error]="showError">
        <ion-input
          #addressInput
          name="manualAddress"
          [(ngModel)]="manualAddress"
          [placeholder]="'LOCATION.ENTER_ADDRESS' | translate"
          class="address-input"
          [disabled]="isLoading">
        </ion-input>
        <!-- <ion-button 
          size="small" 
          fill="solid" 
          color="secondary"
          (click)="geocodeAddress()"
          [disabled]="isLoading || !manualAddress">
          <app-dynamic-icon slot="start" name="search"></app-dynamic-icon>
          <span>{{ 'LOCATION.SEARCH' | translate }}</span>
        </ion-button> -->
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        @if(shouldShowMap()) {
          <ion-button 
            size="small" 
            fill="solid" 
            color="primary"
            (click)="getCurrentLocation()"
            [disabled]="isLoading">
            @if(isLoading) {
              <ion-spinner name="crescent"></ion-spinner>
            } @else {
              <app-dynamic-icon slot="start" name="locate"></app-dynamic-icon>
            }
            <span>{{ 'LOCATION.GET_CURRENT' | translate }}</span>
          </ion-button>
        }
        
        @if(locationData && shouldShowMap()) {
          <ion-button 
            size="small" 
            fill="outline" 
            color="danger"
            (click)="clearLocation()">
            <app-dynamic-icon slot="icon-only" name="close"></app-dynamic-icon>
          </ion-button>
        }
      </div>

      @if(errorMessage) {
        <div class="error-message">
          <strong>{{ 'COMMON.ERROR' | translate }}:</strong>
          <p>{{ errorMessage }}</p>
          @if(errorMessage.includes('authentication') || errorMessage.includes('API key')) {
            <div class="error-help">
              <p><strong>{{ 'LOCATION.TROUBLESHOOTING' | translate }}:</strong></p>
              <ul>
                <li>{{ 'LOCATION.CHECK_API_KEY' | translate }}</li>
                <li>{{ 'LOCATION.ENABLE_APIS' | translate }}</li>
                <li>{{ 'LOCATION.CHECK_BILLING' | translate }}</li>
                <li>{{ 'LOCATION.CHECK_RESTRICTIONS' | translate }}</li>
              </ul>
            </div>
          }
        </div>
      }
    </div>

    <!-- Map Container -->
    @if(shouldShowMap()) {
      <div class="map-wrapper">
        <div #mapContainer class="map-container" id="{{field.key}}"></div>
        @if(!mapInitialized && !errorMessage) {
          <div class="map-loading">
            <ion-spinner name="crescent" color="primary"></ion-spinner>
            <span>{{ 'LOCATION.LOADING_MAP' | translate }}</span>
          </div>
        }
      </div>
    }

    <!-- Location Information -->
    @if(shouldShowMap()) {
      @if(locationData) {
        <div class="location-info">
          <div class="info-row">
            <span class="info-label">{{ 'LOCATION.ADDRESS' | translate }}:</span>
            <span class="info-value">{{ locationData.address }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'LOCATION.COORDINATES' | translate }}:</span>
            <span class="info-value">{{ getFormattedCoordinates() }}</span>
          </div>
        </div>
      } @else {
        <div class="no-location">
          <p>{{ 'LOCATION.NO_LOCATION_SET' | translate }}</p>
          <p class="hint">{{ 'LOCATION.CLICK_MAP_OR_USE_BUTTON' | translate }}</p>
        </div>
      }
    }
  } @else {
    <!-- Disabled Mode: Read-only Display -->
    <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-view'">
      @if(locationData) {
        <div class="location-display">
          <!-- Static Map Preview (optional) -->
          @if(options.formState.showCompactViewWhenDisabled) {
            <div class="compact-location">
              <!-- <app-dynamic-icon name="locate" color="primary"></app-dynamic-icon> -->
              <span>{{ locationData.address }}</span>
            </div>
          } @else {
            <div class="not-compact-location">
              <!-- <app-dynamic-icon name="locate" color="primary"></app-dynamic-icon> -->
              <span>{{ locationData.address }}</span>
            </div>

            @if(shouldShowMap()) {
              <div class="map-preview">
                <div #mapContainer class="map-container-readonly"></div>
              </div>
            }
            @if(shouldShowMap()) {
              <div class="location-info-readonly">
                <div class="info-row">
                  <span class="info-label">{{ 'LOCATION.ADDRESS' | translate }}:</span>
                  <span class="info-value">{{ locationData.address }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">{{ 'LOCATION.COORDINATES' | translate }}:</span>
                  <span class="info-value">{{ getFormattedCoordinates() }}</span>
                </div>
              </div>
            }
          }
        </div>
      } @else {
        <div class="no-location-readonly">
          <span>{{ 'LOCATION.NO_LOCATION' | translate }}</span>
        </div>
      }
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>
